(function () {
  var STORAGE_KEY = 'fw-theme';
  var root = document.documentElement;

  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.getElementById('fw-dark-toggle');
    if (!btn) return;

    updateLabel(btn, root.getAttribute('data-theme'));

    btn.addEventListener('click', function () {
      var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      localStorage.setItem(STORAGE_KEY, next);
      updateLabel(btn, next);
    });

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
      if (!localStorage.getItem(STORAGE_KEY)) {
        var auto = e.matches ? 'dark' : 'light';
        root.setAttribute('data-theme', auto);
        updateLabel(btn, auto);
      }
    });
  });

  function updateLabel(btn, theme) {
    var label = document.getElementById('fw-dark-label');
    if (label) label.textContent = theme === 'dark' ? 'Light Mode' : 'Dark Mode';
    btn.setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
  }
})();